import { useQuery } from "react-query";
import { getAdminChat } from "../../api";
import { API_KEY_GET_CHAT_ADMIN } from "../../helpers";

export const useGetAdminChat = (id: number) => {
  return useQuery([API_KEY_GET_CHAT_ADMIN, id], () => getAdminChat(id));
};
